import { localStg } from '@/utils';

export function isLoggedIn() {
  const user = localStg.get('userInfo')
  return user && user.userId ? true : false
}

export function getUserInfo() {
  const emptyInfo: Auth.UserInfo = {
    userId: '',
    userName: '',
    role: 'ADMIN',
    companies: []
  };
  // On refresh, restore user from localStorage so permission checks
  // don't run with an empty auth state before /auth/user returns.
  const stored = localStg.get('userInfo') as Auth.UserInfo | null;
  if (stored?.userId) {
    return {
      ...emptyInfo,
      ...stored,
      companies: Array.isArray(stored.companies) ? stored.companies : []
    };
  }
  return emptyInfo;
}

export function clearAuthStorage() {
  localStg.remove('userInfo');
  localStg.remove('userImp');
}
